<ng-select
    [(ngModel)]="doctorName"
    bindValue="doctorName"
    bindLabel="doctorName"
    placeholder="Search for doctor"
    typeToSearchText="Search Doctor"
    notFoundText="No Doctors Found"
    dropdownPosition="bottom"
    [multiple]="false"
    [searchable]="true"
    [closeOnSelect]="true"
    [clearOnBackspace]="true"
    [virtualScroll]="true"
    [clearSearchOnAdd]="true"
    [trackByFn]="trackByFn"
    [typeahead]="matrixDoctorsTypeahead$"
    [items]="matrixDoctorsItems$ | async"
    (ngModelChange)="modelChangeFn($event)"
    (clear)="onClear()"
    id="doctor-name"
    name="drName"
    [disabled]="disabled"
    [required]="true">
    <ng-template ng-option-tmp let-item="item" let-index="index">
        {{ item.doctorName }}
    </ng-template>
</ng-select>
